import { AgGrid, Link, Text } from "@jsq/ds/core";
import { globalEnv } from "~/global-env";
import { getInvestingProfileName } from "~/pages/Compliance/CaseDetailsDrawer/Profiles/utils";
import { ProfileNameFields } from "../../utils/types";
import { PositionsTableRowItem } from "../types";
import { noneText, linkStyle } from "./styles_vanilla.css";

type RootProfileCellRendererProps = AgGrid.ICellRendererParams<PositionsTableRowItem>;

export const RootProfileCellRenderer = ({ data }: RootProfileCellRendererProps) => {
  if (!data?.onboardingStatus?.latestInvestingProfile) {
    return <Text className={noneText}>None</Text>;
  }

  const latestInvestingProfile = data.onboardingStatus.latestInvestingProfile;
  const profileId = latestInvestingProfile.id;
  const profileName = getInvestingProfileName(latestInvestingProfile as ProfileNameFields);

  return (
    <Link
      to={`${globalEnv.complianceRoute}/profiles?profileId=${profileId}`}
      icon="link-horizontal"
      shouldOpenInNewTab
      className={linkStyle}
    >
      {profileName}
    </Link>
  );
};
